import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrowLinkComponent } from "./arrow-link.component";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ArrowLinkComponent],
  exports: [ArrowLinkComponent]
})
export class ArrowLinkModule { }
